import React from "react";
import { Accepts, Types } from "@citychallenge/common";
import { connect, ConnectReceivedProps } from "../reactive";
import { defineElement } from "../elements/define-element";

export interface SceneConnectionEvents {
  startBranch: (branch: Types["Branch"]) => void;
  onFinish: () => void;
}

export const SceneConnectionActions = {
  startBranch: Accepts.Branch,
  finish: Accepts.Void,
};

export type SceneConnectionProps = SceneConnectionEvents & ConnectReceivedProps;
class VoidProps {}

class SceneConnection extends React.Component<SceneConnectionProps> {
  constructor(props: SceneConnectionProps) {
    super(props);

    /* Connect actions */
    this.props.connectActions!({
      startBranch: this.props.startBranch,
      finish: this.props.onFinish,
    });
  }

  public render() {
    return null;
  }
}
const SceneConnectionDefinition = defineElement("scene", VoidProps, {
  actions: SceneConnectionActions,
});

export const ConnectedSceneConnection = connect(
  SceneConnectionDefinition,
  SceneConnection
);
